
export { AutoBeam } from './AutoBeam';